import React, { Component } from "react";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import classes from "./SideBar.module.scss";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { TextField } from "@mui/material";
import { boxiPrimary } from "../../../assets/style/colors";
import CampaignCardsContainer from "./CampaignCard/CampaignCardContainer";
import { connect } from "react-redux";
import _ from "lodash";



const pages = [
  {
    display: "Campaign Map",
    path: "/dashboard/map"
  },
  {
    display: "Analytics",
    path: "/dashboard/analytics"
  }
];

const IconA = (props) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="16"
  fill="none"
  viewBox="0 0 18 16"
>
  <path
    fill={props.isTrue? "#fff": '#7D8298'}
    d="M4.583 15.75a.79.79 0 01-.229-.583.79.79 0 01.23-.584l3.978-4c.32-.32.716-.479 1.188-.479s.868.16 1.187.48l1.73 1.729 3.729-3.73a.8.8 0 01.583-.25.8.8 0 01.583.25c.167.167.25.365.25.594 0 .23-.083.427-.25.594L13.854 13.5a1.6 1.6 0 01-1.177.48 1.6 1.6 0 01-1.177-.48l-1.75-1.75-4 4a.814.814 0 01-.573.24.776.776 0 01-.594-.24zm-2.25-.25c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 01-.49-1.177V2.167c0-.459.164-.851.49-1.177C1.482.663 1.875.5 2.333.5H14c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177V5.5c0 .236-.08.434-.24.594a.806.806 0 01-.594.24h-12.5V15.5zm0-10.833H14v-2.5H2.333v2.5z"
  ></path>
</svg>
)

const IconC = (props) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    fill={props.isTrue? "#fff": '#7D8298'}
    fillRule="evenodd"
    d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z"
    clipRule="evenodd"
  ></path>
</svg>
)


class SideBar extends Component {
  state = {
    selected: -1,
    search: '',
    campaignsCards: []
  };

  componentDidMount() {
    switch (window.location.pathname) {
      case "/dashboard/map":
        this.setState({ selected: 0 });
        break;
      case "/dashboard/analytics":
        this.setState({ selected: 1 });
        break;
      default:
        this.setState({ selected: -1 });
        break;
    }
  }

  onLinkClickhandler(id) {
    this.setState({
      selected: id
    });
  }

  onSearchChangeHandler(value) {
    this.setState({
      search: value
    });
  }

  debouncedHandler = _.debounce(value => {
    if (value?.length > 0) {
      const filteredData = Object.keys(this.props.campaigns)
      .filter((key) => {
        return this.props.campaigns[key].name.toLowerCase().includes(value.toLocaleLowerCase())
      })
      .reduce((result, key) => {
        result[key] = this.props.campaigns[key];
        return result;
      }, {});
      this.setState({
        campaignsCards:{...filteredData}
      })
    }else {
      this.setState({
        campaignsCards:{...this.props.campaigns}
      })
    };
  }, 2000);


  render() {
    let selectedClass = [classes.button, classes.selected].join(" ");
    let links = pages.map((page, index) => (
      <Link
        key={index}
        style={{ padding: '0px 15px'}}
        to={page.path}
        onClick={() => this.onLinkClickhandler(index)}
        className={this.state.selected === index ? selectedClass : classes.button}
      >
        {page.display.includes('Campaign Map') ? (
          <>
      <IconC isTrue={this.state.selected === index} /> Campaign Map
          </>
    ) : (
      <>
      <IconA  isTrue={this.state.selected === index}/> Analytics
      </>
    )}
      </Link>
    ));

    return (
      <div className={classes.sideBar}>
        <div className={classes.button_box}>
          {links}
        </div>
        {/* <div className={classes.sidebarSearchBox}>
          <TextField
            placeholder="Search "
            value={this.state.search}
            onChange={(e) => {
              this.onSearchChangeHandler(e.target.value)
              this.debouncedHandler(e.target.value)
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment >
                  <IconButton>
                    <SearchIcon/>
                  </IconButton>
                </InputAdornment>
              ),
              style: { borderRadius: '4px', paddingLeft: '0px', height: '46px'}
            }}
          />
        </div> */}
        <CampaignCardsContainer clientInpersonate={this.props.clientInpersonate} userId={localStorage.getItem('userId')} classes={classes} boxiPrimary={boxiPrimary} campaignsCards={this.props.campaigns} />
        <div className={classes.signOut}>
          {cookies.get("token") && jwtDecode(cookies.get("token")).role !== 4 ? (
            <Link to="/dashboard/admin" className={classes.button}>
              Admin Dashboard
            </Link>
          ) : null}
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    campaigns: state.clientDashboardTemp.campaigns,
    selected: state.clientDashboardTemp.selected,
  };
};



export default connect(mapStateToProps)(SideBar);
